export const featureConstants = {
    ISSUES: 'Issues'
};